export function getView(appointment_overlay) {
  return (
    appointment_overlay.treatment_id &&
    !appointment_overlay.is_external_appointment_id &&
    !appointment_overlay.is_external_treatment_id
  )
}
